<template>
  <div class="page" v-if="init">
    <form v-on:submit.prevent="onSubmit">
      <b-form-group
        label-cols-sm="2"
        label-cols-lg="3"
        id="input-group-name"
        label="Название"
        label-for="input-name"
      >
        <b-form-input
          id="input-name"
          v-model="form.title"
          placeholder="Введите название организации..."
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="2"
        label-cols-lg="3"
        id="input-group-okato"
        label="ОКАТО"
        label-for="input-okato"
      >
        <b-form-input
          id="input-okato"
          v-model="form.okato"
          placeholder="Введите ОКАТО..."
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="2"
        label-cols-lg="3"
        id="input-group-ogrn"
        label="ОГРН"
        label-for="input-ogrn"
      >
        <b-form-input
          id="input-ogrn"
          v-model="form.ogrn"
          placeholder="Введите ОГРН..."
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="2"
        label-cols-lg="3"
        id="input-group-inn"
        label="ИНН"
        label-for="input-inn"
      >
        <b-form-input
          id="input-inn"
          v-model="form.inn"
          placeholder="Введите ИНН..."
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="2"
        label-cols-lg="3"
        id="input-group-kpp"
        label="КПП"
        label-for="input-kpp"
      >
        <b-form-input
          id="input-kpp"
          v-model="form.kpp"
          placeholder="Введите КПП..."
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="2"
        label-cols-lg="3"
        id="input-group-timezone"
        label="Часовой пояс"
        label-for="input-timezone"
      >
        <b-form-select
          id="input-timezone"
          v-model="form.timezone"
          :options="timezones"
        ></b-form-select>
      </b-form-group>

      <div class="form-group buttons">
        <button type="submit" class="btn btn-primary">Сохранить</button>
        <button
          v-on:click="reset()"
          type="button"
          class="btn btn-outline-primary"
        >
          Отменить
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { organizationApi } from '../../services';
export default {
  data: () => ({
    init: false,
    timezones: [
      { text: '(UTC+02:00) Калининград', value: 'Europe/Kaliningrad' },
      { text: '(UTC+03:00) Москва', value: 'Europe/Moscow' },
      { text: '(UTC+04:00) Астрахань', value: 'Europe/Astrakhan' },
      { text: '(UTC+04:00) Ульяновск', value: 'Europe/Ulyanovsk' },
      { text: '(UTC+04:00) Самара', value: 'Europe/Samara' },
      { text: '(UTC+04:00) Саратов', value: 'Europe/Saratov' },
      { text: '(UTC+04:00) Волгоград', value: 'Europe/Volgograd' },
      { text: '(UTC+05:00) Екатеринбург', value: 'Asia/Yekaterinburg' },
      { text: '(UTC+06:00) Омск', value: 'Asia/Omsk' },
      { text: '(UTC+07:00) Новосибирск', value: 'Asia/Novosibirsk' },
      { text: '(UTC+07:00) Красноярск', value: 'Asia/Krasnoyarsk' },
      { text: '(UTC+07:00) Барнаул', value: 'Asia/Barnaul' },
      { text: '(UTC+07:00) Томск', value: 'Asia/Tomsk' },
      { text: '(UTC+07:00) Новокузнецк', value: 'Asia/Novokuznetsk' },
      { text: '(UTC+08:00) Иркутск', value: 'Asia/Irkutsk' },
      { text: '(UTC+09:00) Якутск', value: 'Asia/Yakutsk' },
      { text: '(UTC+09:00) Чита', value: 'Asia/Chita' },
      { text: '(UTC+10:00) Владивосток', value: 'Asia/Vladivostok' },
      { text: '(UTC+11:00) Магадан', value: 'Asia/Magadan' },
      { text: '(UTC+12:00) Анадырь', value: 'Asia/Anadyr' }
    ],
    prevForm: null,
    form: {
      title: null,
      okato: null,
      ogrn: null,
      inn: null,
      kpp: null,
      timezone: null
    }
  }),
  async created() {
    const loading = this.$loading.show();
    try {
      this.form = await organizationApi.get();
      this.prevForm = { ...this.form };
    } catch (e) {
      console.error(e);
    }
    this.init = true;
    loading.hide();
  },
  methods: {
    async onSubmit() {
      try {
        await organizationApi.update(this.form);
        this.prevForm = { ...this.form };
        this.$bvToast.toast('Изменения сохранены', {
          title: 'Выполнено',
          autoHideDelay: 10000,
          variant: 'success'
        });
      } catch (err) {
        this.$bvToast.toast('Не удалось сохранить изменения', {
          title: 'Ошибка сохранения',
          autoHideDelay: 10000,
          variant: 'danger'
        });
      }
    },
    reset() {
      this.form = { ...this.prevForm };
    }
  }
};
</script>
